import { TireItem } from '@1po/1po-bff-fe-spec/generated/tire/response/TireSearchResponse';
import { LIFECYCLE_W3 } from 'domains/catalog/Catalog.types';
import { getStocksMapV2, NON_MKTP } from 'domains/references';
import { FOUND, isLoading, NOT_FOUND } from 'utils';

export const isTireAvailable = (tire: TireItem, stocks: ReturnType<typeof getStocksMapV2>): boolean => {
  const stock = stocks.get(tire.partNumber);
  const warehouses = stock?.data?.get(NON_MKTP)?.warehouses ?? [];
  const hasLocalStock = warehouses.some((warehouse) => warehouse.type === 'LOCAL' && warehouse.confirmedQuantity > 0);

  if (tire.lifeCycle !== LIFECYCLE_W3) {
    return true;
  }

  return !((stock?.searchStatus === FOUND && !hasLocalStock) || stock?.searchStatus === NOT_FOUND);
};

export const getSomeStockMissingFirstLoad = (
  refsForStocksLength: number,
  hasUnresolvedStockEntries: boolean,
  stockStatuses: Array<string | undefined>,
): boolean => {
  if (refsForStocksLength === 0) {
    return false;
  }

  return hasUnresolvedStockEntries || stockStatuses.some((status) => isLoading(status));
};

export const splitTiresByExactMatch = (
  filteredTires: TireItem[],
): {
  exactMatchTires: TireItem[];
  nonExactMatchTires: TireItem[];
} =>
  filteredTires.reduce(
    (acc: { exactMatchTires: TireItem[]; nonExactMatchTires: TireItem[] }, tire) => {
      tire.isExactSearchMatch ? acc.exactMatchTires.push(tire) : acc.nonExactMatchTires.push(tire);
      return acc;
    },
    { exactMatchTires: [], nonExactMatchTires: [] },
  );
